
<template>
<nav>
    <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img
                    src="../../assets/images/financial-norms-ratios-logo.png"
                    alt="Financial Norms and Ratios of Businesses"
                >
            </b-navbar-item>
        </template>
        <template slot="start">
            <b-navbar-item  @click="goHome()">
                Home
            </b-navbar-item>
            <b-navbar-item  @click="buyReports()">
                Buy Reports
            </b-navbar-item>
              <b-navbar-item  @click="doAbout()">
                About
            </b-navbar-item>
                   <b-navbar-item  @click="doContact()">
                Contact
            </b-navbar-item>
            </b-navbar-item>
                   <b-navbar-item  href="http://blog.normsandratios.com">
                Blog
            </b-navbar-item>
            <b-navbar-dropdown class="hoverable"   label="Resources">
                <b-navbar-item @click="doFAQ()">
                    FAQ
                </b-navbar-item>
                <b-navbar-item @click="doSampleReports()">
                    Sample Reports
                </b-navbar-item>

                            </b-navbar-dropdown>

            <b-navbar-dropdown class="hoverable"   label="Tools">
                <b-navbar-item @click="doToolsNAICS()">
                    NAICS Industry Resources
                </b-navbar-item>
                <b-navbar-item >
                    APIs (Q2-2020)
                </b-navbar-item>
                <b-navbar-item >
                    Premium Datasets (Q3-2020)
                </b-navbar-item>
                <b-navbar-item >
                    Beta Release v0.93.05
                </b-navbar-item>
              </b-navbar-dropdown>

        </template>

        <template slot="end">
        <router-link v-if="isProfileLoaded"  class="navbar-item"   to="/account">Profile</router-link>
        <router-link v-if="isProfileLoaded"  class="navbar-item"   to="/orders">Order History</router-link>
<router-link v-if="isAuthenticated"  class="navbar-item"   to="/logout">Logout</router-link>
<router-link v-if="!isAuthenticated && !authLoading"  class="navbar-item"   to="/login">Login</router-link>
<router-link v-if="!isAuthenticated && !authLoading"  class="navbar-item"   to="/register">Register</router-link>
<router-link v-if="isAuthenticated"  class="navbar-item"   to="#">{{authCredentials.email}}</router-link>

        </template>
    </b-navbar>
    </nav>
</template>
<style>
.navbar-item.has-dropdown.is-active > .navbar-dropdown {
    display: block;
}
</style>
<script>


import LoginModal from "../modals/LoginModal"
import { mapGetters , mapState} from "vuex";
// import { USER_REQUEST } from "../store/actions/user";
import { REPORT_PARAMETERS } from "../../store/actions/report";

export default {
    name: 'Navbar',
    props: ['hideNavLogins'],
    data() {
        return {
            showNav: false,
            logo: './static/logo.png',
            navLogin: true
        }
    },
    components: {
        LoginModal
    },
    mounted() {

        this.navLogin = this.hideNavLogins
        if(this.hideNavLogins == undefined) {
            this.navLogin = true;
        }
    },
    computed: {
  ...mapGetters(["authCredentials","isAuthenticated", "authStatus", "isProfileLoaded","authLoading"]),
  ...mapState({
  authLoading: state => state.auth.status === "loading",
  name: state => `${state.user.profile.title} ${state.user.profile.name}`
})
/*
  loading: function() {
    return this.authStatus === "loading" && !this.isAuthenticated;
  }
  */
},
    methods: {
        showSubMenu() {

            let m;
            let e;
            try {
                e = event.target;
                m = event.target.nextSibling.nextSibling.classList;

            } catch (error) {
                e = event.target.parentNode;
                m = event.target.parentNode.nextSibling.nextSibling.classList;

            }

            let class1 = e.childNodes[1].classList.contains('mdi-arrow-down') ? 'mdi-arrow-down' : 'mdi-arrow-up';
            let class2 = class1 == 'mdi-arrow-down' ? 'mdi-arrow-up' : 'mdi-arrow-down';

            e.childNodes[1].classList.replace(class1, class2)

            m.toggle('is-hidden-touch')
        },
        openLogin() {
          console.log("Login pressed")
            this.$modal.open({
                parent: this,
                component: LoginModal,
                hasModalCArd: true,
                props: {
                }
            })
        },
        goHome() {
        this.$router.push({ name: "Home" });
        },
        doLogout() {
        this.$router.push({ name: "BuyReports" });
        },
        doAbout() {
        this.$router.push({ name: "About" });
        },
        doContact() {
        this.$router.push({ name: "Contact" });
        },
        doFAQ() {
        this.$router.push({ name: "FAQ" });
        },
        doSampleReports() {
        // this.$router.push({ name: "SampleReports" });


        var r = { report:"Standard-1", salestype: "Range",salesexact:"", naics: "213000",   salesrange: "Range-10->$25M-$50M", state: "",     zip: "" }
        this.$store.commit(REPORT_PARAMETERS, r)
        this.$router.push({ name: "ViewReport" }).catch(err => {});
        },
        doLiveReports() {

        console.log("doLiveReports()")
        var theParameters = {reportType: "NormRange", sales: 0,
           naics: "213000", range: "10", state: "",
           zip: "" };

        this.$store.commit(REPORT_PARAMETERS, theParameters)
        this.$router.push({ name: "ViewReport" }).catch(err => {});


        },
                doToolsNAICS() {
        this.$router.push({ name: "ToolsNAICS" });
        },
                        buyReports() {
                if(this.isAuthenticated && !this.authLoading ) {
        this.$router.push({ name: "BuyReports" });
        } else {
        this.$router.push({ name: "Login" });

        }
        },
        myMethod() {
            console.log("...")
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/features/Navbar.vue